export default __webpack_public_path__ + "static/media/medicine.3030d2ae.svg";